export default {"src":"/_next/static/media/KeepaLogoFa.051f954b.svg","height":27,"width":27};